import Vue from 'vue'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/en'
import 'dayjs/locale/tr'

dayjs.extend(LocalizedFormat)

Vue.use(dayjs)
